import { WorkerLocation } from '@sentry/types';

import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

export const getHostNameFromUrl = (url: Location | string): string => {
    const urlRegExp = /(.+:\/\/)?([^/]+)(\/.*)*/i;

    const urlParts = urlRegExp.exec(url.toString());

    if (!urlParts || urlParts.length < 4) {
        return '';
    }

    return urlParts[2];
};

export const getUrlParams = (query: Location | WorkerLocation): Record<string, string> => {
    const search = query.search.substr(1);
    const query_string: Record<string, string> = {};
    if (search) {
        let keyValuePair, paramName, paramValue;
        const str = search.split('#')[0];
        const params = str.split('&');

        for (let i = 0; i < params.length; i++) {
            keyValuePair = params[i].split('=');
            paramName = keyValuePair.shift() || '';
            paramValue = keyValuePair.join('=') || '';
            query_string[paramName] = decodeURIComponent(paramValue.replace(/\+/g, ' '));
        }
    }
    return query_string;
};

export const getUrlString = (params: Record<string, any>): string => {
    const urlParams = Object.keys(params).map(key => {
        return `${key}=${params[key]}`;
    });
    return urlParams.length ? `${urlParams.join('&')}` : '';
};

export const hasStrInUrl = (str: string): boolean => {
    if (isServerSide()) {
        return false;
    }

    const href = window?.location?.href;
    return href ? href.includes(str) : false;
};

export const isValidLink = (urlString: string): boolean => {
    let url: URL;
    const isProtocol = urlString.match(/http[s]?/gi);
    if (isProtocol !== null && isProtocol?.length !== 1) {
        return false;
    }
    try {
        url = new URL(urlString);
        const isSpace = url.host.match(/\s[[:space:]]/g);
        if (isSpace?.length) {
            return false;
        }
        const lastLetter = url.host.slice(-1);
        const isSymbols = lastLetter.match(/[^a-z0-9]/gi);
        return !isSymbols?.length;
    } catch (e) {
        return false;
    }
};

export { nonPermanentRedirect, permanentRedirect } from './redirects';
